module.exports = function (ngModule) {
    // header
    ngModule.controller('HeaderController', require("./header"));
    // sidebar
    ngModule.controller('sidebarController', require("./sidebar"));
    // main
    ngModule.controller('mainPageController', require("./main"));
}


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/main/index.js
 **/